import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ComponentSlider from '@kapost/react-component-slider';
import Moment from 'moment';
import React, { Component, Fragment } from 'react';
import { Breadcrumb, Col, Container, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { BearingTemperatureSensor } from '../../Home/Fleet/Components/BearingTemperatureSensor';
import TrailerBogie from '../../Home/Fleet/Components/TrailerBogie';
import Mask from '../../assets/img/mask.png';
import { axleboxService } from '../../services/axlebox.service';
import { chartService } from '../../services/chart.service';
import { eventService } from '../../services/event.service';
import { fleetService } from '../../services/fleet.service';
import { GetConfigurationPanel } from '../../services/userManagment.service';
import TreeSelectComponent from '../utils/filters/treeSelect';
import Header from '../utils/header/header';
import { vehicleTreeConstructor } from '../utils/state';
import MainFooter from './../footer/mainFooter';

import EventsTable from '../../Home/Fleet/Components/EventsTable';
import { getHierarchy } from '../../actions';
import {
  constgetCarriageforBogie,
  getByReferenceOrDesignation,
  getFleetOrTrainOrCarriageOrBogie
} from '../utils/state/mstp_Vehicles';
import FleetMapWrapperv02 from './../../Home/Fleet/Components/FleetMapWrapper/FleetMapWrapperv02';
import analyzeIcon from './../../assets/img/generalSvg/analyzeIcon';

import { history } from '../../../src/helpers/index';
import { GetHierarchyForFleetDropdown } from '../../services/common.service';
import AssetInformation from './AssetInformation';
import FleetAssetPanel from './FleetAssetPanel';
import Modal from './InformationButton';
import ModalDocuments from './modalDocuments';
import ModalPreFilters from './modalPreFilters';

const TopViewContainer = styled(Row)`
  margin: 0 2px;
`;

const TrainFilterContainerOne = styled.div`
  height: 100%;
`;

const BreadcrumbContainer = styled(Breadcrumb)`
  display: flex;
  justify-content: flex-end;
  .breadcrumb {
    margin: 0.5rem 0;
  }
`;

const LoadingBreadcrumb = styled.div`
  min-height: 54px;
`;

const TrainFilterContainerTwo = styled.div`
  display: flex;
  align-items: center;
  padding-left: 20px;
`;

const TrainFilterContainerFour = styled.div`
  transform: translateY(-8px);

  margin-left: 15px;
`;

const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin: 20px 0px;
  padding: 20px 0;
  font-size: 32px;
  text-align: center;
`;

const LoadingTempChart = styled.div`
  display: flex;
  background-color: var(--white);
  border-radius: 2px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  min-height: 304px;
  justify-content: center;
  align-items: center;
  flex: 1;
  max-width: 100%;
`;

const ChartsContainer = styled(Col)`
  display: flex;
  justify-content: flex-start;
`;

const NoDataContainer = styled.div`
  flex-flow: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin: 10px 30%;
  padding: 60px;
  font-size: 32px;
  text-align: center;
  box-shadow: 0 0.0625rem 0.375rem rgba(0, 0, 0, 0.12),
    0 0.0625rem 0.25rem rgba(0, 0, 0, 0.12);
`;

const BodyContainer = styled.div`
  min-height: calc(100vh - 258px);
  margin: 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DataContainer = styled(Row)`
  margin: 0px 0px 0px 0px;
`;

const RowTable = styled(Row)`
  margin-right: 0;
  margin-left: 0;
  min-height: 230px;
`;

const renderLeftArrow = () => (
  <img src={Mask} className="mask maskright" alt="" />
);
const renderRightArrow = () => <img src={Mask} className="mask" alt="" />;

const ReferenceLevel = {
  Train: 'Train',
  Trains: 'Trains',
  Carriage: 'Carriage',
  Carriages: 'Carriages',
  Bogie: 'Bogie',
  Bogies: 'Bogies',
  Fleet: 'Fleet',
  Fleets: 'Fleets',
  Axlebox: 'axlebox'
};

function isFleet(level) {
  return level === ReferenceLevel.Fleet || level === ReferenceLevel.Fleets;
}

function isTrain(level) {
  return level === ReferenceLevel.Train || level === ReferenceLevel.Trains;
}

function isBogie(level) {
  return level === ReferenceLevel.Bogie || level === ReferenceLevel.Bogies;
}

function isCarriage(level) {
  return (
    level === ReferenceLevel.Carriage || level === ReferenceLevel.Carriages
  );
}

function coalesce(value1, value2) {
  if (value1 != null && value1 !== undefined && value1 !== '') return value1;

  return value2;
}

function isAxlebox(level) {
  return level === ReferenceLevel.Axlebox;
}

function getReferenceProperty(element) {
  return coalesce(element.Reference, element.reference);
}

class VehicleMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vehicleLoading: props.trainSelected ? true : false,
      bogies: [],
      positionClicked: 0,
      trainSelected: props.trainSelected,
      carriageSelected: {},
      axleboxSelected: {},
      assetInformation: {},
      kpi: {},
      hierarchyDesignation: [],
      hierarchyReference: [],
      fleet: [],
      startDate: new Date().setDate(new Date().getDate() - 1),
      events: [],
      eventsForTopView: [],
      scopedEvents: [],
      points: [],
      lastLevel: false,
      tabSelected: 'status',
      loadingTemperatureRadar: true,
      loadingKPI: true,
      loadingEventTable: false,
      loadingAssetInformationTab: true,
      loadingRadar: false,
      toggleModal: false,
      modalDocumentOpen: false,
      roles: [],
      listVehiclePreSelected: [],
      modalPreFiltersOpen: false,
      hierarchyLevel: undefined
    };

    this.hideModal = this.hideModal.bind(this);
    this.showModal = this.showModal.bind(this);
  }

  getDisabled = value => {
    return this.state.treeData?.find(e => e.value === value)?.disabled;
  };

  getHash = value => {
    return this.state.treeData?.find(e => e.value === value)?.key;
  };

  getNode = value => {
    return this.state.treeData?.find(e => e.value === value);
  };

  getChilds = value => {
    return this.state.treeData?.filter(e => e.pId === value);
  };

  getAllChild = (value, level) => {
    let result = this.getChilds(value);
    if (isTrain(level)) return result;
    let resultCarriages = [];
    result.forEach(e => {
      resultCarriages = resultCarriages.concat(this.getChilds(e.key));
    });
    if (isCarriage(level)) {
      return resultCarriages;
    }
    let resultBogies = [];
    resultCarriages.forEach(e => {
      resultBogies = resultBogies.concat(this.getChilds(e.key));
    });
    if (isBogie(level)) {
      return resultBogies;
    }
  };

  loadUniquefilter = filterVehicle => {
    return this.getHash(filterVehicle);
  };

  loadMultiplesfilter = aPrechargedVehicle => {
    const level = sessionStorage.getItem('typeVehicle');
    let filters = [];
    if (!Array.isArray(aPrechargedVehicle))
      filters = filters.concat(this.getAllChild(aPrechargedVehicle, level));
    else
      aPrechargedVehicle.forEach(filter => {
        if (this.getDisabled(filter) && this.getNode(filter).pId === 0)
          filters = filters.concat(this.getAllChild(filter, level));
        else filters.push(this.getNode(filter));
      });

    this.setState({
      listVehiclePreSelected: filters,
      modalPreFiltersOpen: true
    });
  };

  checkPrefilters = filterVehicles => {
    let prechargedVehicle = filterVehicles;
    let aPrechargedVehicle = prechargedVehicle?.split(',');
    if (
      aPrechargedVehicle &&
      aPrechargedVehicle.length === 1 &&
      !this.getDisabled(aPrechargedVehicle[0])
    ) {
      return this.loadUniquefilter(aPrechargedVehicle[0]);
    } else {
      return this.loadMultiplesfilter(aPrechargedVehicle);
    }
  };

  async componentDidMount() {
    this.props.changeMenu('fleet');

    if (this.props.hierarchy.length === 0) {
      this.props.getHierarchy();
    }
    // const treeData = await GetHierarchybyVehicleDetails();
    const client = sessionStorage.getItem('client');
    const level = sessionStorage.getItem('typeVehicle');
    let filterVehicles = sessionStorage.getItem('filterVehicles');
    const treeData = await GetHierarchyForFleetDropdown(client, level);
    const configClients = await GetConfigurationPanel([client]);
    const roles = configClients.data[0].Roles;
    this.setState({ treeData, roles });

    let prechargedVehicle = this.checkPrefilters(filterVehicles);
    if (!prechargedVehicle) prechargedVehicle = this.props.trainSelected;
    if (prechargedVehicle) {
      const { Vehicle: vehicle } = await fleetService.vehicle(
        prechargedVehicle
      );
      this.setState(
        {
          vehicle,
          hierarchyDesignation: vehicle.Designation,
          hierarchyReference: getReferenceProperty(vehicle)
        },
        async () => {
          const fleet = await fleetService.fleet();
          this.setState({ fleet });
        }
      );

      this.setState({ loadingKPI: true });

      const [events, eventsForTopView, kpi] = await Promise.all([
        eventService.getAllEventsByVehicle(
          prechargedVehicle,
          coalesce(vehicle.Reference, vehicle.reference),
          level
        ),
        eventService.getAllEventsForTopViewByVehicle(
          prechargedVehicle,
          coalesce(vehicle.Reference, vehicle.reference),
          level
        ),

        this.scopedKPI(level, prechargedVehicle)
      ]);

      this.setState(
        { kpi, events, eventsForTopView, loadingKPI: false, prechargedVehicle },
        () => {
          this.scopedEvents(level);
          this.scopedGps(
            level,
            coalesce(vehicle.Reference, vehicle.reference),
            prechargedVehicle
          );
          this.getTemperaturesRadarInfoByVehicle({
            hash: prechargedVehicle,
            date: new Date().setDate(new Date().getDate() - 1),
            level
          });
        }
      );
      // change to vehicle Reference eventually.

      // fleetService
      //   .gpsByVehicle(
      //     prechargedVehicle,
      //     coalesce(vehicle.Reference, vehicle.reference),
      //     level
      //   )
      //   .then(points => this.setState({ mapInfo: points }));

      /**
       * Bogies Declaration
       */
      if (Object.keys(this.state.vehicle).length > 0) {
        this.bogieConstructor(this.state.vehicle);
        this.setState({ vehicleLoading: false });
      }
    }
    if (document.getElementsByClassName('caret-right')[0])
      document.getElementsByClassName('caret-right')[0].click();
  }

  handlerPreFilter = value => {
    sessionStorage.setItem('filterVehicles', value);
    let key = this.getHash(value);
    let obj = [
      {},
      {
        triggerNode: {
          props: {
            eventKey: key
          }
        }
      }
    ];
    obj.value = value;
    this.setState({ modalPreFiltersOpen: false, listVehiclePreSelected: [] });
    this.handleHierarchyFleetOnChange(obj);

    setTimeout(this.lastTrain, 3000);
  };

  lastTrain = () => {
    if (document.getElementsByClassName('caret-right')[0])
      document.getElementsByClassName('caret-right')[0].click();
  };

  toHistory = date => {
    const hashSelected =
      getReferenceProperty(this.state.axleboxSelected) ||
      getReferenceProperty(this.state.carriageSelected) ||
      this.state.trainSelected;

    this.props.toHistory(hashSelected, date);
    history.push('/history');
  };

  setmodalDocumentOpen = () => {
    this.setState({ modalDocumentOpen: !this.state.modalDocumentOpen });
  };

  bogieConstructor = vehicle => {
    let customUIC = this.state.vehicle.SetUIC;
    customUIC = customUIC.replace(/['.*+?^${}()|[\]\\]/g, ',');
    customUIC = customUIC.replace(/,,/g, ',');
    let bogieUICList = customUIC.split(',');
    bogieUICList = bogieUICList.filter(UIC => UIC !== ''); // Remove empty values
    let bogieIndex = 0;

    vehicle.Units.forEach(unit => {
      unit.Bogies.forEach((bogie, indexUnit) => {
        const newBogie = bogie;
        if (indexUnit === 0) {
          newBogie.displayInCarriage = 'firstBogie';
        } else if (indexUnit === unit.Bogies.length - 1) {
          newBogie.displayInCarriage = 'lastBogie';
        } else {
          newBogie.displayInCarriage = 'sharedBogie';
        }
        newBogie.UIC = bogieUICList[bogieIndex] || '';
        newBogie.positionOrder = bogieIndex;
        this.setState(prevstate => {
          return { bogies: [...prevstate.bogies, newBogie] };
        });
        bogieIndex += 1;
      });
    });
  };

  scopedPoints = scopedPoints => {
    let bluePointsIndex = [];
    const totalPoints =
      (this.state.skf_radarTempVehicle &&
        this.state.skf_radarTempVehicle.map(point => point.thevalue)) ||
      [];

    this.state.skf_radarTempVehicle &&
      this.state.skf_radarTempVehicle.forEach((point, index) => {
        scopedPoints.forEach(scopedPoint => {
          if (
            scopedPoint.sensorFunctionalLocationSerialNumber ===
            point.sensorFunctionalLocationSerialNumber
          ) {
            bluePointsIndex = [...bluePointsIndex, index];
            /**Aqui actualizar el dato azul con la respuesta del api */
          }
        });
      });
    const bluePointsFinal =
      this.state.skf_radarTempVehicle &&
      this.state.skf_radarTempVehicle.map((point, index) => {
        if (bluePointsIndex.includes(index)) {
          return point.thevalue;
        } else {
          return 0;
        }
      });
    const greyPointsFinal =
      this.state.skf_radarTempVehicle &&
      this.state.skf_radarTempVehicle.map((point, index) => {
        if (bluePointsIndex.includes(index)) {
          return 0;
        } else {
          return point.thevalue;
        }
      });

    const skf_bearingTemperature = {
      skf_bearingTemperatureToShow: bluePointsFinal,
      skf_bearingTemperatureToHide: greyPointsFinal,
      skf_bearingTemperatureTotal: totalPoints
    };

    return skf_bearingTemperature;
  };

  /***********************Get Thresholds****************************/
  getThresholds = tempArr => {
    const allThresholds = tempArr.map(obj => {
      return {
        threshold: [
          obj.temperatureAlarmLowerLimit,
          obj.temperatureAlarmUpperLimit
        ],
        ...obj
      };
    });
    const thresholdsArr = allThresholds.map(obj => {
      return [...obj.threshold];
    });
    let radarThresholds = Array.from(
      new Set(thresholdsArr.map(JSON.stringify)),
      JSON.parse
    );
    return radarThresholds;
  };

  /***********************Get Temperatures Radar Values by Vehicle****************************/
  getTemperaturesRadarInfoByVehicle = async ({ hash, date, level }) => {
    const formatedDate = Moment(date).format('YYYY-MM-DD');
    this.setState({ loadingRadar: true }, async () => {
      //When "View Details" is clicked in dashboard instead dropdown event "this.state.trainSelected" is null and we know is a train-vehicle.
      const skf_getSensorMaxTempByVehicle = await eventService.getSensorMaxTempByVehicle(
        hash,
        formatedDate,
        this.state.trainSelected && this.state.trainSelected.length > 0
          ? this.state.trainSelected
          : getReferenceProperty(this.state.vehicle),
        level
      );

      let skf_bearingTemperature = {};
      if (
        skf_getSensorMaxTempByVehicle &&
        skf_getSensorMaxTempByVehicle.length !== 0
      ) {
        skf_bearingTemperature = {
          skf_bearingTemperatureToShow: skf_getSensorMaxTempByVehicle.map(
            ({ thevalue }) => thevalue
          ),
          skf_bearingTemperatureToHide: skf_getSensorMaxTempByVehicle.map(
            () => 0
          ),
          skf_bearingTemperatureTotal: skf_getSensorMaxTempByVehicle.map(
            ({ thevalue }) => thevalue
          )
        };
      } else {
        skf_bearingTemperature = {
          skf_bearingTemperatureToShow: [],
          skf_bearingTemperatureToHide: [],
          skf_bearingTemperatureTotal: []
        };
      }

      const radarThresholds = this.getThresholds(skf_getSensorMaxTempByVehicle);
      const skf_SensorMaxTempSortedByDate = [...skf_getSensorMaxTempByVehicle];
      this.setState({
        loadingRadar: false,
        skf_bearingTemperature,
        skf_radarTempVehicle: skf_getSensorMaxTempByVehicle,
        radarThresholds,
        // Start date is the last available date.
        startDate:
          skf_SensorMaxTempSortedByDate &&
          skf_SensorMaxTempSortedByDate.length !== 0
            ? skf_SensorMaxTempSortedByDate.sort(
                (a, b) => new Date(b.theDatetime) - new Date(a.theDatetime)
              )[0].theDatetime
            : date
            ? new Date(date)
            : new Date()
      });
    });
  };
  /***********************Get Temperatures Radar Values by Carriage****************************/
  getTemperaturesRadarInfoByCarriage = async ({
    scopedHash,
    vehicleReference,
    date
  }) => {
    const formatedDate = Moment(date).format('YYYY-MM-DD');
    this.setState({ loadingRadar: true }, async () => {
      const carriagePoints = await chartService.getSensorMaxTempByCarriage(
        scopedHash,
        vehicleReference,
        formatedDate
      );
      const coloredPoints = this.scopedPoints(carriagePoints);
      this.setState({
        loadingRadar: false,
        skf_bearingTemperature: coloredPoints
      });
    });
  };

  /***********************Get Temperatures Radar Values by Axlebox****************************/
  getTemperaturesRadarInfoByFunctionalLocation = async ({
    scopedHash,
    vehicleReference,
    date
  }) => {
    let coloredPoints = {};
    if (this.state.axleboxSelected.IMEI === '') {
      /**If imei === '', we need to all radar points in gray. */
      coloredPoints = this.scopedPoints([]);
    } else {
      /**If imei !== '', this will find the selected axlebox and paint it blue on the radar.  */
      const formatedDate = Moment(date).format('YYYY-MM-DD');
      const axleboxPoints = await chartService.getSensorMaxTempByFunctionalLocation(
        scopedHash,
        vehicleReference,
        formatedDate
      );
      coloredPoints = this.scopedPoints(axleboxPoints);
    }

    this.setState({
      loadingRadar: false,
      skf_bearingTemperature: coloredPoints
    });
  };
  /***********************Get Temperatures Radar Values by Vehicle and (carriage or axlebox)****************************/
  /**This function is called because when you change the date on the radar, we need to refresh not only the selected points,
   * but the entire radar (including thresholds), so, we are calling the whole radar to get the new updated gray points, then, get the blue ones (root).
   */
  getTemperaturesRadarInfoByVehicleAndScopedAsset = async ({
    hash,
    scopedHash,
    root,
    date
  }) => {
    const formatedDate = Moment(date).format('YYYY-MM-DD');
    this.setState({ loadingRadar: true }, async () => {
      const skf_getSensorMaxTempByVehicle = await eventService.getSensorMaxTempByVehicle(
        scopedHash,
        formatedDate,
        hash,
        root
      );

      let skf_bearingTemperature = {};
      if (
        skf_getSensorMaxTempByVehicle &&
        skf_getSensorMaxTempByVehicle.length !== 0
      ) {
        skf_bearingTemperature = {
          skf_bearingTemperatureToShow: skf_getSensorMaxTempByVehicle.map(
            ({ thevalue }) => thevalue
          ),
          skf_bearingTemperatureToHide: skf_getSensorMaxTempByVehicle.map(
            () => 0
          ),
          skf_bearingTemperatureTotal: skf_getSensorMaxTempByVehicle.map(
            ({ thevalue }) => thevalue
          )
        };
      }
      const radarThresholds = this.getThresholds(skf_getSensorMaxTempByVehicle);

      const skf_SensorMaxTempSortedByDate = [...skf_getSensorMaxTempByVehicle];

      this.setState(
        {
          skf_bearingTemperature,
          skf_radarTempVehicle: skf_getSensorMaxTempByVehicle,
          radarThresholds,
          startDate:
            skf_SensorMaxTempSortedByDate &&
            skf_SensorMaxTempSortedByDate.length !== 0
              ? skf_SensorMaxTempSortedByDate.sort(
                  (a, b) => new Date(b.theDatetime) - new Date(a.theDatetime)
                )[0].theDatetime
              : date
              ? new Date(date)
              : new Date()
        },
        async () => {
          let coloredPoints = [];
          if (isCarriage(root)) {
            const carriagePoints = await chartService.getSensorMaxTempByCarriage(
              hash,
              scopedHash,
              formatedDate
            );
            coloredPoints = this.scopedPoints(carriagePoints);
          } else if (isAxlebox(root)) {
            const axleboxPoints = await chartService.getSensorMaxTempByFunctionalLocation(
              scopedHash,
              hash,
              formatedDate
            );
            coloredPoints = this.scopedPoints(axleboxPoints);
          }
          if (
            this.state.skf_radarTempVehicle &&
            this.state.skf_radarTempVehicle.length < 1
          ) {
            this.setState({
              loadingRadar: false,
              skf_bearingTemperature: {}
            });
          } else {
            this.setState({
              loadingRadar: false,
              skf_bearingTemperature: coloredPoints
            });
          }
        }
      );
    });
  };

  /**Function to be called when the datepicker changes,
   * it calls the temperature radar information for the whole train, then (if needed)
   * it calls by axle or carriage to mark the blue points.
   */
  handleDayChange = e => {
    /**If axlebox is selected */
    if (
      Object.entries(this.state.axleboxSelected) &&
      Object.entries(this.state.axleboxSelected).length > 1 &&
      this.state.axleboxSelected.constructor === Object
    ) {
      this.setState(
        {
          startDate: new Date(e),
          loadingRadar: true
        },
        () => {
          this.getTemperaturesRadarInfoByVehicleAndScopedAsset({
            hash: coalesce(
              getReferenceProperty(this.state.vehicle),
              this.state.prechargedVehicle
            ),
            scopedHash: getReferenceProperty(this.state.axleboxSelected),
            root: ReferenceLevel.Axlebox,
            date: this.state.startDate
          });
        }
      );
    } else if (
      Object.entries(this.state.carriageSelected) &&
      Object.entries(this.state.carriageSelected).length > 1 &&
      this.state.carriageSelected.constructor === Object
    ) {
      /**If carriage is selected */
      this.setState({ startDate: new Date(e) }, () => {
        this.getTemperaturesRadarInfoByVehicleAndScopedAsset({
          hash: getReferenceProperty(this.state.carriageSelected),
          scopedHash: this.state.trainSelected,
          root: ReferenceLevel.Carriages,
          date: this.state.startDate
        });
      });
    } else {
      /**If vehicle is selected */
      const level = sessionStorage.getItem('typeVehicle');

      this.setState({ startDate: new Date(e) }, () => {
        this.getTemperaturesRadarInfoByVehicle({
          hash: coalesce(
            getReferenceProperty(this.state.vehicle),
            this.state.prechargedVehicle
          ),
          date: this.state.startDate,
          level: level
        });
      });
    }
  };
  /**Function to be called when a new train from the dropdown is clicked.
   * It calls vehicledetails, events, radar, map kpi for the new train.
   */
  handleHierarchyFleetOnChange = e => {
    const eventReference = e[1].triggerNode.props.eventKey;
    const eventDesignation = e[0][0];
    const eventLevel = e[1].triggerNode.props.level;
    const configurationLevel = sessionStorage.getItem('typeVehicle');
    sessionStorage.setItem('vehicle', eventReference);

    let trainReferenceSelected = undefined;
    let vehicleReferenceApplied = undefined;
    let carriageSelected = undefined;
    let bogieSelected = undefined;
    let hierarchyLevel = undefined;

    const object_FleetOrTrainOrCarriageOrBogie = getFleetOrTrainOrCarriageOrBogie(
      {
        vehicles: this.props.hierarchy,
        carriages: this.state.treeData,
        reference: eventReference,
        level: eventLevel
      }
    );

    if (isFleet(eventLevel)) {
      vehicleReferenceApplied = eventReference;
      hierarchyLevel = ReferenceLevel.Fleets;
    } else if (isCarriage(eventLevel)) {
      trainReferenceSelected = object_FleetOrTrainOrCarriageOrBogie.pId;
      carriageSelected = object_FleetOrTrainOrCarriageOrBogie;
      vehicleReferenceApplied = eventReference;
      bogieSelected = undefined;
      hierarchyLevel = ReferenceLevel.Carriages;
      if (isTrain(configurationLevel))
        vehicleReferenceApplied = trainReferenceSelected;
    } else if (isBogie(eventLevel)) {
      carriageSelected = constgetCarriageforBogie({
        carriages: this.state.treeData,
        designation: object_FleetOrTrainOrCarriageOrBogie.pId
      });
      trainReferenceSelected = carriageSelected.pId;
      bogieSelected = object_FleetOrTrainOrCarriageOrBogie;
      vehicleReferenceApplied = eventReference;
      hierarchyLevel = ReferenceLevel.Bogies;
      if (isTrain(configurationLevel))
        vehicleReferenceApplied = trainReferenceSelected;
      if (isCarriage(configurationLevel))
        vehicleReferenceApplied = carriageSelected.key;
    } else {
      trainReferenceSelected = getReferenceProperty(
        object_FleetOrTrainOrCarriageOrBogie.Vehicle
      );
      carriageSelected = undefined;
      bogieSelected = undefined;
      hierarchyLevel = ReferenceLevel.Trains;
      vehicleReferenceApplied = getReferenceProperty(
        object_FleetOrTrainOrCarriageOrBogie.Vehicle
      );
    }

    this.setState(
      {
        loadingEventTable: true,
        vehicleLoading: true,
        hierarchyDesignation: eventDesignation,
        hierarchyReference: eventReference,
        trainSelected: trainReferenceSelected,
        positionClicked: 0,
        bogies: [],
        hierarchyLevel: hierarchyLevel
      },
      async () => {
        const { Vehicle: vehicle } = await fleetService.vehicle(
          vehicleReferenceApplied,
          configurationLevel
        );

        const events = await eventService.getAllEventsByVehicle(
          vehicleReferenceApplied,
          trainReferenceSelected,
          configurationLevel
        );
        const eventsForTopView = await eventService.getAllEventsForTopViewByVehicle(
          vehicleReferenceApplied,
          trainReferenceSelected,
          configurationLevel
        );

        this.setState(
          {
            vehicle,
            events,
            eventsForTopView,
            axleboxSelected: {},
            carriageSelected: {},
            tabSelected: 'status',
            lastLevel: false,
            assetInformation: {},
            vehicleLoading: carriageSelected ? true : false,
            loadingEventTable: true
          },
          async () => {
            if (vehicle) {
              if (!carriageSelected && !bogieSelected) {
                this.getTemperaturesRadarInfoByVehicle({
                  hash: eventReference,
                  date: this.state.startDate,
                  level: hierarchyLevel
                });
              }
              this.bogieConstructor(vehicle);
            }

            //if carriage is selected we don't need to reload twice the scope events, it is called again in handleClickOnCarriage and handleClickOnBogie.
            if (!carriageSelected && !bogieSelected) this.scopedEvents();

            this.scopedGps(
              configurationLevel,
              trainReferenceSelected,
              trainReferenceSelected
            );
            this.setState({ loadingKPI: true });
            const kpi = await this.scopedKPI(
              configurationLevel,
              trainReferenceSelected
            );
            this.setState(
              {
                kpi,
                loadingKPI: false,
                loadingEventTable: carriageSelected || bogieSelected //Loading for this levels
              },
              () => {
                if (bogieSelected) {
                  this.handleClickOnBogie(bogieSelected.key);
                } else if (carriageSelected) {
                  this.handleClickOnCarriage(
                    carriageSelected.pId,
                    carriageSelected.key,
                    carriageSelected.title
                  );
                }
              }
            );
          }
        );
        this.lastTrain();
      }
    );
  };

  scopedKPI = async (root, rootReference) => {
    let kpi = {};
    if (!this.state.vehicle) return kpi;

    const vehicleReference = coalesce(
      getReferenceProperty(this.state.vehicle),
      this.state.prechargedVehicle
    );
    if (isAxlebox(root)) {
      kpi = await fleetService.kpiByFunctionalLocation(
        rootReference,
        vehicleReference
      );
    } else
      kpi = await fleetService.kpiByVehicle(
        rootReference,
        vehicleReference,
        root
      );
    if (kpi && kpi.isIMx) kpi.IMxRail = true;
    return kpi;
  };

  scopedEvents = root => {
    const allEvents = this.state.events;
    let eventsToRender = [];
    if (isCarriage(root)) {
      eventsToRender = allEvents.filter(event => {
        return (
          event.carriageReference ===
            getReferenceProperty(this.state.carriageSelected) ||
          event.carriageReference === null ||
          event.carriageReference === undefined
        );
      });
    } else if (isAxlebox(root)) {
      const axleboxReference =
        (this.state.axleboxSelected &&
          getReferenceProperty(this.state.axleboxSelected)) ||
        {};

      eventsToRender = allEvents.filter(event => {
        return event.functionalLocationReference === axleboxReference;
      });
    } else if (isBogie(root)) {
      const bogieReference =
        (this.state.bogieSelected &&
          getReferenceProperty(this.state.bogieSelected)) ||
        undefined;

      eventsToRender = allEvents.filter(event => {
        return event.bogieReference === bogieReference || !bogieReference;
      });
    } else {
      eventsToRender = allEvents;
    }

    const eventsToRenderSorted = eventsToRender.sort((a, b) => {
      let da = new Date(a.alarmTimestamp),
        db = new Date(b.alarmTimestamp);
      return da - db;
    });

    this.setState({ scopedEvents: eventsToRenderSorted });
  };

  scopedGps = async (root, vehicleReference, scopedReference) => {
    let response = [];
    if (isAxlebox(root)) {
      response = await fleetService.gpsByFunctionalLocation(
        vehicleReference,
        scopedReference
      );
    } else {
      response = await fleetService.gpsByVehicle(
        scopedReference,
        vehicleReference,
        root
      );
    }
    this.setState({
      mapInfo: response
    });
  };

  isMotor(bogie) {
    // If the bogie UIC is a number, don't have motor
    let result = true;
    const firstChar = bogie.UIC.charAt(0);
    if (firstChar >= '0' && firstChar <= '9') {
      // it is a number
      result = false;
    }
    return result;
  }

  handleSelect = key => {
    this.setState({ tabSelected: key });
  };

  handleClickOnAxlebox = async (...variables) => {
    if (!variables[6]) return;
    this.setState(
      {
        vehicleLoading: true,
        loadingRadar: true,
        bogieSelected: variables[2],
        hierarchyReference: getReferenceProperty(variables[2]),
        hierarchyLevel: ReferenceLevel.Bogies
      },
      async () => {
        const axleboxSelected = getByReferenceOrDesignation({
          vehicles: [this.state.vehicle],
          reference: variables[5]
        });

        let carriageSelected = getByReferenceOrDesignation({
          vehicles: [this.state.vehicle],
          reference: axleboxSelected.carriageReference
        });

        carriageSelected = {
          ...carriageSelected,
          vehicleNumber: carriageSelected.designation
        };

        this.setState({
          positionClicked: carriageSelected.position
        });

        const assetInformation = await axleboxService.getSensorByReference(
          variables[6],
          coalesce(
            axleboxSelected?.vehicleReference,
            this.state.prechargedVehicle
          )
        );

        if (!axleboxSelected) {
          this.setState({
            vehicleLoading: false,
            loadingRadar: false,
            bogieSelected: undefined
          });
          return;
        }

        this.setState(
          {
            assetInformation: assetInformation[0],
            vehicleLoading: false,
            loadingAssetInformationTab: false,
            axleboxSelected,
            carriageSelected,
            lastLevel: true
          },
          async () => {
            this.scopedEvents(ReferenceLevel.Axlebox);
            this.getTemperaturesRadarInfoByFunctionalLocation({
              scopedHash: coalesce(
                axleboxSelected.reference,
                axleboxSelected.Reference
              ),
              vehicleReference: coalesce(
                this.state.axleboxSelected?.vehicleReference,
                this.state.prechargedVehicle
              ),
              //date: new Date("2018/08/12")
              date: this.state.startDate
            });
            this.scopedGps(
              ReferenceLevel.Axlebox,
              coalesce(
                this.state.axleboxSelected?.vehicleReference,
                this.state.prechargedVehicle
              ),
              coalesce(axleboxSelected.reference, axleboxSelected.Reference)
            );
            this.setState({ loadingKPI: true });

            const kpi = await this.scopedKPI(
              ReferenceLevel.Axlebox,
              axleboxSelected.assetKey
            );
            this.setState({
              kpi,
              loadingKPI: false
            });
            /*  } */
          }
        );
      }
    );
  };

  handleClickOnBogie = async (bogieReference, ...variables) => {
    if (variables && variables.length > 0)
      bogieReference = coalesce(
        bogieReference,
        getReferenceProperty(variables[2])
      );

    const axleboxSelected = {};
    const carriageReference = this.state.treeData.find(
      e => e.key === bogieReference
    ).pId;
    const carriageSelected = this.state.vehicle.Carriages.find(
      e => getReferenceProperty(e) === carriageReference
    );
    carriageSelected.vehicleNumber = carriageSelected.VehicleNumber;
    const bogie = this.state.bogies.find(
      e => getReferenceProperty(e) === bogieReference
    );
    this.setState({
      vehicleLoading: true,
      loadingRadar: true,
      loadingKPI: true,
      carriageSelected,
      axleboxSelected,
      assetInformation: {},
      lastLevel: false,
      hierarchyReference: bogieReference,
      hierarchyLevel: ReferenceLevel.Bogies,
      positionClicked: carriageSelected.Position
    });

    this.scopedGps(
      ReferenceLevel.Bogies,
      getReferenceProperty(this.state.vehicle),
      getReferenceProperty(bogie)
    ).then(e => this.setState({ loadingRadar: false }));

    const kpi = await this.scopedKPI(
      ReferenceLevel.Bogies,
      getReferenceProperty(bogie)
    );

    this.getTemperaturesRadarInfoByVehicle({
      hash: getReferenceProperty(bogie),
      date: this.state.startDate,
      level: ReferenceLevel.Bogies
    }).then(e => this.setState({ vehicleLoading: false }));
    this.setState({ bogieSelected: bogie, kpi }, () => {
      this.scopedEvents(ReferenceLevel.Bogies);
      this.setState({ loadingKPI: false, loadingEventTable: false });
    });
  };

  async handleClickOnCarriage(
    vehicleReference,
    carriageReference,
    designation
  ) {
    const { Position: positionClicked } = this.state.vehicle.Carriages.find(
      carriage => getReferenceProperty(carriage) === carriageReference
    );
    this.setState(
      {
        bogieSelected: undefined,
        vehicleLoading: true,
        lastLevel: false,
        axleboxSelected: {},
        assetInformation: {},
        tabSelected: 'status',
        hierarchyReference: carriageReference,
        hierarchyLevel: ReferenceLevel.Carriage,

        carriageSelected: {
          reference: carriageReference,
          vehicleReference,
          vehicleNumber: designation
        },
        positionClicked
      },
      async () => {
        this.getTemperaturesRadarInfoByVehicle({
          hash: carriageReference,
          date: this.state.startDate,
          level: ReferenceLevel.Carriages
        });

        this.scopedEvents(ReferenceLevel.Carriages);
        this.scopedGps(
          ReferenceLevel.Carriages,
          vehicleReference,
          carriageReference
        );
        this.setState({
          loadingKPI: true,
          loadingEventTable: false
        });

        const kpi = await this.scopedKPI(
          ReferenceLevel.Carriages,
          carriageReference
        );
        this.setState({ kpi, vehicleLoading: false, loadingKPI: false });
      }
    );
  }

  handleClickBreadcrumb = async ({ root }) => {
    if (isCarriage(root)) {
      this.setState({
        loadingKPI: true,
        hierarchyReference: getReferenceProperty(this.state.carriageSelected),
        hierarchyLevel: ReferenceLevel.Carriages,
        positionClicked: this.state.carriageSelected.position
      });
      const kpi = await this.scopedKPI(
        ReferenceLevel.Carriages,
        getReferenceProperty(this.state.carriageSelected)
      );
      this.setState(
        {
          bogieSelected: undefined,
          axleboxSelected: {},
          lastLevel: false,
          assetInformation: {},
          tabSelected: 'status',
          kpi,
          loadingKPI: false
        },
        () => {
          // call all functions for carriage.
          this.getTemperaturesRadarInfoByCarriage({
            scopedHash: getReferenceProperty(this.state.carriageSelected),
            vehicleReference: this.state.carriageSelected.vehicleReference,
            // date: new Date("2018/08/12")
            date: this.state.startDate
            //date: date ? new Date(date) : new Date()
          });
          this.scopedEvents(ReferenceLevel.Carriages);
          this.scopedGps(
            ReferenceLevel.Carriages,
            getReferenceProperty(this.state.vehicle),
            getReferenceProperty(this.state.carriageSelected)
          );
        }
      );
    } else if (isBogie(root)) {
      this.setState({
        loadingKPI: true,
        hierarchyReference: getReferenceProperty(this.state.bogieSelected),
        hierarchyLevel: ReferenceLevel.Bogies,
        positionClicked: this.state.carriageSelected.position
      });
      const kpi = await this.scopedKPI(
        ReferenceLevel.Bogies,
        getReferenceProperty(this.state.bogieSelected)
      );
      this.setState(
        {
          axleboxSelected: {},
          lastLevel: false,
          assetInformation: {},
          tabSelected: 'status',
          kpi,
          loadingKPI: false
        },
        () => {
          // call all functions for carriage.
          fleetService
            .maxTempInfoByBogie(
              getReferenceProperty(this.state.bogieSelected),
              getReferenceProperty(this.state.vehicle)
            )
            .then(e => this.setState({ vehicleLoading: false }));
          this.scopedEvents(ReferenceLevel.Bogies);
          this.scopedGps(
            ReferenceLevel.Bogies,
            getReferenceProperty(this.state.vehicle),
            getReferenceProperty(this.state.bogieSelected)
          );
        }
      );
    } else if (isTrain(root)) {
      this.setState({
        loadingKPI: true,
        hierarchyReference: coalesce(
          this.state.trainSelected,
          getReferenceProperty(this.state.vehicle)
        ),
        hierarchyLevel: ReferenceLevel.Trains
      });

      const kpi = await this.scopedKPI(
        ReferenceLevel.Trains,
        coalesce(
          getReferenceProperty(this.state.vehicle),
          this.state.trainSelected
        )
      );

      this.setState(
        {
          bogieSelected: undefined,
          axleboxSelected: {},
          lastLevel: false,
          assetInformation: {},
          tabSelected: 'status',
          carriageSelected: {},
          scopedEvents: this.state.events,
          positionClicked: 0,
          kpi,
          loadingKPI: false
        },
        () => {
          // call all functions for vehicle.
          this.getTemperaturesRadarInfoByVehicle({
            hash: coalesce(
              getReferenceProperty(this.state.vehicle),
              this.state.trainSelected
            ),
            // date: new Date("2018/08/12")
            date: this.state.startDate,
            level: this.state.hierarchyLevel
            //date: date ? new Date(date) : new Date()
          });
          this.scopedGps(
            ReferenceLevel.Trains,
            coalesce(
              getReferenceProperty(this.state.vehicle),
              this.state.trainSelected
            ),
            coalesce(
              getReferenceProperty(this.state.vehicle),
              this.state.trainSelected
            )
          );
        }
      );
    } else {
      this.setState({
        hierarchyLevel: undefined
      });
    }
  };

  isVehicleSelected = () => {
    //TODO, check this , maybe we can delete this
    let response = false;
    if (!getReferenceProperty(this.state.carriageSelected)) {
      // If carriageSelected has reference, we are on Carriage or Axle level
      response = true;
    }
    return response;
  };

  showModal() {
    this.setState({ toggleModal: true });
  }

  hideModal() {
    this.setState({ toggleModal: false });
  }

  getFirmwareVerion = tempVersion => {
    const arr = new ArrayBuffer(4);
    const view = new DataView(arr);

    view.setUint32(0, tempVersion, true);

    const majorVersion = view.getUint8(3);
    const minorVersion = view.getUint8(2);

    const arr2 = new ArrayBuffer(2);
    const view2 = new DataView(arr2);

    view2.setUint8(0, view.getUint8(1), true);

    view2.setUint8(1, view.getUint8(0), true);

    const revision = view2.getUint16(0) >> 1;

    return `${majorVersion}.${minorVersion}.${revision}`;
  };

  getVehicleNumberCarriage = () => {
    const configurationLevel = sessionStorage.getItem('typeVehicle');

    if (
      this.state.carriageSelected &&
      this.state.carriageSelected.vehicleNumber !== undefined &&
      this.state.carriageSelected.vehicleNumber != null
    )
      return this.state.carriageSelected.vehicleNumber;
    if (this.state.bogieSelected && this.state.bogieSelected.VehicleNumber)
      return this.state.bogieSelected.VehicleNumber;
    else if (this.state.vehicle && isCarriage(configurationLevel))
      return this.state.vehicle.Carriages[0].VehicleNumber;
    else if (this.state.vehicle && isBogie(configurationLevel))
      return this.state.vehicle.Carriages[0].VehicleNumber;
    return coalesce(
      this.state.vehicle?.Designation,
      this.state.prechargedVehicle
    );
  };

  getPositionBogie = () => {
    const configurationLevel = sessionStorage.getItem('typeVehicle');
    if (
      this.state.bogieSelected &&
      this.state.bogieSelected.positionOrder !== undefined &&
      this.state.bogieSelected.positionOrder != null
    )
      return this.state.bogieSelected.positionOrder;
    if (isBogie(configurationLevel) && this.state.vehicle)
      return this.state.vehicle.Units[0].Bogies[0].positionOrder;
    return undefined;
  };

  render() {
    const {
      carriageSelected,
      axleboxSelected,
      assetInformation,
      loadingAssetInformationTab,
      vehicle,
      hierarchyReference,
      bogies,
      positionClicked,
      bogieSelected,
      startDate,
      eventsForTopView,
      lastLevel,
      vehicleLoading,
      scopedEvents,
      loadingEventTable,
      kpi,
      mapInfo,
      skf_bearingTemperature,
      loadingRadar,
      treeData
    } = this.state;

    const configurationLevel = sessionStorage.getItem('typeVehicle');
    const { dropdownData } = this.props;
    let nameInfoText = '';
    let nameInfo = configurationLevel;
    if (
      lastLevel ||
      isBogie(configurationLevel) ||
      (bogieSelected &&
        Object.keys(bogieSelected) &&
        Object.keys(bogieSelected).length > 0)
    ) {
      nameInfo = 'Asset';
      nameInfoText = 'Asset';
    } else if (
      (Object.keys(carriageSelected) &&
        Object.keys(carriageSelected).length > 0) ||
      isCarriage(configurationLevel)
    ) {
      nameInfo = 'Vehicle';
      nameInfoText = 'Asset';
    } else {
      nameInfo = 'Train';
      nameInfoText = 'Vehicle';
    }

    let vehicleNumber = this.getVehicleNumberCarriage();

    let bogiePosition = this.getPositionBogie();
    let carriages = vehicle?.Carriages;
    if (isBogie(configurationLevel) && carriages?.length > 1) {
      carriages = [vehicle?.Carriages[0]];
      carriages[0].LabelVehicleNumber =
        vehicle?.Carriages[0].VehicleNumber +
        ' - ' +
        vehicle?.Carriages[1].VehicleNumber;
    }

    return (
      <>
        <Modal
          handleHideModal={this.hideModal}
          toggleModal={this.state.toggleModal ? 'block' : 'none'}
        >
          {loadingAssetInformationTab ? (
            <LoadingContainer>
              <div className="spinner-border sfk_spinner" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </LoadingContainer>
          ) : (
            <>
              <div className="customText14">Asset Information</div>
              <AssetInformation
                loadingAssetInformationTab={loadingAssetInformationTab}
                trainOperator={assetInformation.Train_Operator}
                bogie={assetInformation.Bogie_Serial_Number}
                wheelset={assetInformation.Wheelset_Serial_Number}
                diameter={assetInformation.Wheel_Diameter}
                axlebox={axleboxSelected.designation}
                brand={
                  axleboxSelected.bearings
                    ? axleboxSelected.bearings[0].OEM
                    : ''
                }
                bearingSN={assetInformation.Bearing_Serial_Number}
                designation={
                  axleboxSelected.bearings
                    ? axleboxSelected.bearings[0].Designation
                    : ''
                }
                id={assetInformation.Identifier}
                firmware={this.getFirmwareVerion(
                  assetInformation.Firmware_Version
                )}
                axleboxLocation={assetInformation.Sensor_Location_Angle}
                axleboxOrientation={assetInformation.Sensor_Orientation_Angle}
                trainName={assetInformation.Train_Name}
                installationDate={Moment.utc(assetInformation.Added).format(
                  'DD/MM/YYYY'
                )}
              />
            </>
          )}
        </Modal>

        <ModalPreFilters
          vehicles={this.state.listVehiclePreSelected}
          isOpen={this.state.modalPreFiltersOpen}
          treeData={treeData}
          setFilter={this.handlerPreFilter}
          closeModal={() =>
            this.setState({
              modalPreFiltersOpen: false,
              listVehiclePreSelected: []
            })
          }
        ></ModalPreFilters>

        <ModalDocuments
          treeData={treeData}
          roles={this.state.roles}
          isOpen={this.state.modalDocumentOpen}
          closeModal={this.setmodalDocumentOpen}
          setID={vehicle && vehicle.Designation}
          vehicleNumber={vehicleNumber}
          bogiePosition={bogiePosition}
        ></ModalDocuments>
        <Header
          title={nameInfo}
          subtitle={sessionStorage.getItem('userName')}
          typeVehicle={configurationLevel}
          firstNumber={(kpi && kpi.totalVehicles) || 0}
          secondNumber={(kpi && kpi.totalRed) || 0} // cambiar
          thirdNumber={(kpi && kpi.totalAmber) || 0} // cambiar
          firstText={nameInfo}
          secondText={nameInfoText}
          thirdText={nameInfoText}
        />

        <Container fluid="true" className="dFlex">
          <Row fluid="true" style={{ marginLeft: 9, marginRight: 0 }}>
            {/* Dropdown menu */}
            <Col xl={6} md={6} sm={6} xs={6}>
              <TrainFilterContainerOne className="text-left">
                <TrainFilterContainerTwo>
                  <TrainFilterContainerFour>
                    <TreeSelectComponent
                      title=""
                      placeholder={'Search or Select'}
                      skf_TreeData={treeData}
                      onChange={e => this.handleHierarchyFleetOnChange(e)}
                      singleSelect
                      spinner={dropdownData === 0}
                      valuesSelected={hierarchyReference}
                    />
                  </TrainFilterContainerFour>
                </TrainFilterContainerTwo>
              </TrainFilterContainerOne>
            </Col>
            {/** BreadCrumbs */}
            {vehicle && Object.keys(vehicle).length > 0 ? (
              <Col xl={6} md={6} sm={6} xs={6}>
                <div className="vCenter">
                  {/** BreadCrumb of Traction/Fleet */}
                  <BreadcrumbContainer className="breadCrumbSKF">
                    <Breadcrumb.Item
                      onClick={() => {
                        this.setState(
                          {
                            axleboxSelected: {},
                            carriageSelected: {},
                            positionClicked: 0,
                            assetInformation: {},
                            tabSelected: 'status'
                          },
                          () => this.scopedEvents()
                        );
                      }}
                    >
                      {vehicle.Traction}
                    </Breadcrumb.Item>
                    {/** BreadCrumb of Train/Vehicle*/}
                    <Breadcrumb.Item
                      onClick={() => {
                        if (isTrain(configurationLevel))
                          this.handleClickBreadcrumb({
                            root: ReferenceLevel.Trains
                          });
                        this.scopedEvents();
                      }}
                    >
                      {vehicle && vehicle.Designation}
                    </Breadcrumb.Item>
                    {/** BreadCrumb of Carriage */}
                    {((carriageSelected &&
                      carriageSelected.vehicleNumber &&
                      carriageSelected.vehicleNumber.length > 0) ||
                      isBogie(configurationLevel) ||
                      isCarriage(configurationLevel)) && (
                      <Breadcrumb.Item
                        onClick={() => {
                          if (
                            isTrain(configurationLevel) ||
                            isCarriage(configurationLevel)
                          )
                            this.handleClickBreadcrumb({
                              root: ReferenceLevel.Carriages
                            });
                        }}
                      >
                        {isBogie(configurationLevel) ||
                        isCarriage(configurationLevel)
                          ? vehicle?.Carriages[0]?.VehicleNumber
                          : carriageSelected.vehicleNumber}
                      </Breadcrumb.Item>
                    )}
                    {/**BreadCrumb of Bogie*/}
                    {(this.state.bogieSelected ||
                      (axleboxSelected &&
                        axleboxSelected.designation &&
                        axleboxSelected.designation.length > 0) ||
                      isBogie(configurationLevel)) && (
                      <Breadcrumb.Item
                        onClick={() => {
                          if (
                            isTrain(configurationLevel) ||
                            isCarriage(configurationLevel) ||
                            isBogie(configurationLevel)
                          )
                            this.handleClickBreadcrumb({
                              root: ReferenceLevel.Bogies
                            });
                        }}
                      >
                        {this.state.bogieSelected?.Name ?? '?'}
                      </Breadcrumb.Item>
                    )}
                    {/** BreadCrumb of Axlebox*/}
                    {carriageSelected &&
                      carriageSelected.vehicleNumber &&
                      carriageSelected.vehicleNumber.length > 0 &&
                      axleboxSelected &&
                      axleboxSelected.designation &&
                      axleboxSelected.designation.length > 0 && (
                        <Breadcrumb.Item onClick={() => null}>
                          {axleboxSelected.designation}
                          <button
                            onClick={this.showModal}
                            className="info-button"
                            type="button"
                          >
                            <FontAwesomeIcon icon={faInfoCircle} />
                          </button>
                        </Breadcrumb.Item>
                      )}
                  </BreadcrumbContainer>
                </div>
              </Col>
            ) : (
              <LoadingBreadcrumb></LoadingBreadcrumb>
            )}
          </Row>
          {vehicle ||
          vehicleLoading ||
          this.props.trainSelected ||
          (sessionStorage.getItem('filterVehicles') !== '' &&
            this.state.listVehiclePreSelected.length === 0) ? (
            <Fragment>
              <TopViewContainer>
                <Col xl={12} className="page-box-shadow trainDetailsView">
                  {vehicleLoading ? (
                    <LoadingContainer>
                      <div className="spinner-border sfk_spinner" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </LoadingContainer>
                  ) : (
                    vehicle &&
                    Object.keys(vehicle).length > 0 && (
                      <div className="insideTrain maxHeight pl-2">
                        <div className="fleet-datetime-group ml-1 trainTopView mb-0 font-weight-bold pb-0">
                          Train Top View
                        </div>
                        <ComponentSlider
                          renderLeftArrow={renderLeftArrow}
                          renderRightArrow={renderRightArrow}
                        >
                          <ul
                            id="listTrains"
                            className=" listTrains listMixedTrain"
                            ref={getReferenceProperty(vehicle)}
                          >
                            {' '}
                            {bogies
                              .sort(function(a, b) {
                                return b.positionOrder - a.positionOrder;
                              })
                              .map((bogie, idx) => {
                                if (
                                  (bogieSelected &&
                                    bogieSelected.displayInCarriage ===
                                      bogie.displayInCarriage &&
                                    isBogie(configurationLevel)) ||
                                  !isBogie(configurationLevel) ||
                                  !bogieSelected
                                ) {
                                  return (
                                    <li
                                      key={idx}
                                      className={bogie.displayInCarriage}
                                    >
                                      <Container className="topViewUnitCouple">
                                        <Row className="fullRow row-fluid align-items-center">
                                          <Col
                                            className={'col-fluid colAleft '}
                                          >
                                            <TrailerBogie
                                              axleBoxReference={getReferenceProperty(
                                                axleboxSelected
                                              )}
                                              bogieSelected={bogieSelected}
                                              lastLevel={lastLevel}
                                              isMotor={this.isMotor(bogie)}
                                              carriages={vehicle.Carriages}
                                              IMxRail={this.state.kpi.IMxRail}
                                              bogie={bogie}
                                              clickBogie={
                                                this.handleClickOnBogie
                                              }
                                              clickElement={
                                                this.handleClickOnAxlebox
                                              }
                                              events={this.state.events}
                                              positionClicked={positionClicked}
                                              wheelsets={vehicle.Wheelsets}
                                              unitWheelSets={bogie.Wheelsets}
                                              allWheelWithEvents={
                                                eventsForTopView
                                              }
                                            />
                                          </Col>
                                        </Row>
                                      </Container>
                                    </li>
                                  );
                                } else {
                                  return (
                                    <Container className="topViewUnitCouple">
                                      <Row className="fullRow row-fluid align-items-center">
                                        <Col className={'col-fluid colAleft '}>
                                          <div></div>
                                        </Col>
                                      </Row>
                                    </Container>
                                  );
                                }
                              })}
                            <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</li>
                          </ul>

                          <ul
                            className={`${getReferenceProperty(
                              vehicle
                            )} listTrains marginTopSlide`}
                            ref={getReferenceProperty(vehicle)}
                          >
                            {carriages
                              .sort(function(a, b) {
                                return b.Position - a.Position;
                              })
                              .map(carriage => {
                                let carriagePosition = 'middleTopView';

                                if (
                                  carriages &&
                                  carriage.Position === carriages.length &&
                                  !isBogie(configurationLevel)
                                ) {
                                  carriagePosition = 'startTopView';
                                } else if (
                                  carriage.Position === 1 &&
                                  !isBogie(configurationLevel)
                                ) {
                                  carriagePosition = 'endTopView';
                                }

                                return (
                                  <li key={carriage.Reference}>
                                    <Container
                                      onClick={() =>
                                        this.handleClickOnCarriage(
                                          getReferenceProperty(vehicle),
                                          getReferenceProperty(carriage),
                                          carriage.VehicleNumber
                                        )
                                      }
                                      className={
                                        isBogie(configurationLevel)
                                          ? 'middleTopViewBogie'
                                          : `topView ${carriagePosition}`
                                      }
                                    >
                                      <div className="positionVehicle">
                                        {!isBogie(configurationLevel)
                                          ? carriage.Position
                                          : ''}
                                      </div>
                                    </Container>
                                    <div className="textCenter marginTopVehicle">
                                      <span className="customText12 customGrey">
                                        Vehicle:&nbsp;
                                        <span className="dark">
                                          <strong>
                                            {carriage.LabelVehicleNumber
                                              ? carriage.LabelVehicleNumber
                                              : carriage.VehicleNumber}
                                          </strong>
                                        </span>
                                      </span>
                                    </div>
                                  </li>
                                );
                              })}
                            <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</li>
                          </ul>
                        </ComponentSlider>
                      </div>
                    )
                  )}
                </Col>
              </TopViewContainer>
              <DataContainer className="d-flex flex1">
                <Col
                  lg={8}
                  md={7}
                  xs={7}
                  style={{ marginLeft: '-2px' }}
                  className="w-100"
                >
                  <Row className="flex1 main-background fixedMargins">
                    <Col
                      lg={this.state.kpi.IMxRail ? 12 : 8}
                      xs={12}
                      md={12}
                      className="dFlex"
                    >
                      <FleetAssetPanel
                        kpi={this.state.kpi}
                        isLoading={this.state.loadingKPI}
                      />
                    </Col>
                    {!this.state.kpi.IMxRail && (
                      <ChartsContainer
                        className="w-100 resetMargins"
                        lg={4}
                        xs={12}
                        md={12}
                      >
                        {!loadingRadar && skf_bearingTemperature ? (
                          <BearingTemperatureSensor
                            handleDayChange={this.handleDayChange}
                            selected={new Date(startDate)}
                            isLoading={false}
                            totalSensors={
                              this.state.skf_bearingTemperature
                                .skf_bearingTemperatureTotal
                            }
                            sensorsToShow={
                              this.state.skf_bearingTemperature
                                .skf_bearingTemperatureToShow
                            }
                            sensorsToHide={
                              this.state.skf_bearingTemperature
                                .skf_bearingTemperatureToHide
                            }
                            thresholds={
                              this.state.radarThresholds &&
                              this.state.radarThresholds.length === 1
                                ? this.state.radarThresholds
                                : false
                            }
                            showLabel={false}
                            labelValue={''}
                            referenceToShow={this.toHistory}
                            showDetailBtn={lastLevel}
                            labels={this.state.skf_radarTempVehicle}
                          />
                        ) : (
                          <LoadingTempChart>
                            <div
                              className="spinner-border sfk_spinner"
                              role="status"
                            >
                              <span className="sr-only">Loading...</span>
                            </div>
                          </LoadingTempChart>
                        )}
                      </ChartsContainer>
                    )}
                  </Row>

                  {/* New Event table */}
                  {/* loadingEventTable SPINNER PARA EVENTOS AL CAMBIAR UN TREN. */}
                  <RowTable className="page-box-shadow marginTop marginBottomCustom">
                    <div className="fleet-datetime-group ml-1 trainTopView mb-0 font-weight-bold pb-0">
                      Active events
                    </div>
                    {loadingEventTable ? (
                      <LoadingContainer>
                        <div
                          className="spinner-border sfk_spinner"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </LoadingContainer>
                    ) : (
                      <Container className="event-container">
                        {scopedEvents && scopedEvents.length > 0 && (
                          <EventsTable eventsData={scopedEvents} />
                        )}
                        {!scopedEvents && (
                          <div className="noEvents">No Active Events</div>
                        )}
                        {scopedEvents && scopedEvents.length === 0 && (
                          <div className="noEvents">No Active events</div>
                        )}
                      </Container>
                    )}
                  </RowTable>
                </Col>
                <Col
                  lg={4}
                  md={5}
                  xs={5}
                  className="d-flex marginBottomCustom marginTop"
                >
                  <Container>
                    <Row>
                      {this.state.kpi.IMxRail && (
                        <ChartsContainer
                          className="w-100 resetMargins"
                          lg={12}
                          xs={12}
                        >
                          {!loadingRadar && skf_bearingTemperature ? (
                            <BearingTemperatureSensor
                              handleDayChange={this.handleDayChange}
                              selected={new Date(startDate)}
                              isLoading={false}
                              totalSensors={
                                this.state.skf_bearingTemperature
                                  .skf_bearingTemperatureTotal
                              }
                              sensorsToShow={
                                this.state.skf_bearingTemperature
                                  .skf_bearingTemperatureToShow
                              }
                              sensorsToHide={
                                this.state.skf_bearingTemperature
                                  .skf_bearingTemperatureToHide
                              }
                              thresholds={
                                this.state.radarThresholds &&
                                this.state.radarThresholds.length === 1
                                  ? this.state.radarThresholds
                                  : false
                              }
                              showLabel={false}
                              labelValue={''}
                              referenceToShow={this.toHistory}
                              showDetailBtn={lastLevel}
                              labels={this.state.skf_radarTempVehicle}
                            />
                          ) : (
                            <LoadingTempChart>
                              <div
                                className="spinner-border sfk_spinner"
                                role="status"
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            </LoadingTempChart>
                          )}
                        </ChartsContainer>
                      )}
                    </Row>
                    <Row
                      className={this.state.kpi.IMxRail ? 'marginTop' : ''}
                      style={{ marginLeft: -10 }}
                    >
                      <Col className="page-box-shadow dFlex resetMargins">
                        <Row className="map-title-container pt-2">
                          <Col>
                            <p className="page-box-map-main-title">
                              {nameInfo} History Map
                            </p>
                          </Col>
                          <Col>
                            <p className="lastDays">Last 7 days</p>
                          </Col>
                        </Row>
                        {/*************** Google Map *******************/}
                        <Row className="resetMargins page-box flex1">
                          {vehicleLoading ? (
                            <LoadingContainer>
                              <div
                                className="spinner-border sfk_spinner"
                                role="status"
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            </LoadingContainer>
                          ) : (
                            <FleetMapWrapperv02
                              className="h-100"
                              clickMarker={() => null} //handle function empty
                              scopedPoints={mapInfo} //puntos de la llamada
                              currentLocation={this.state.currentLatLng}
                            />
                          )}
                        </Row>
                        {/*************** Density of Taken Measurements *******************/}
                        <Row fluid="true" className="marginInfoFleet">
                          <Col xs={5}>
                            <span className="fleetInfoMapTitle">
                              Density of Taken Measurements:
                            </span>
                          </Col>
                          <Col xs={2}> </Col>
                          <Col xs={5}>
                            <Row className="gradient-container">
                              <Col xs={12}>
                                <div className="gradient"> </div>
                              </Col>
                              <Col xs={12}>
                                <Row>
                                  <Col xs={6} className="gradient-low-label">
                                    <p> Low </p>
                                  </Col>
                                  <Col xs={6} className="gradient-high-label">
                                    <p> High </p>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        {/* </div> */}
                      </Col>
                    </Row>
                  </Container>
                </Col>
              </DataContainer>
            </Fragment>
          ) : (
            <BodyContainer>
              <NoDataContainer className="AutoHeight">
                <>
                  {analyzeIcon}
                  <div>
                    Select a train or vehicle in the filter for detailed view
                  </div>
                </>
              </NoDataContainer>
            </BodyContainer>
          )}

          <MainFooter />
        </Container>
      </>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toHistory: (payload, date) => {
      dispatch({ type: 'SET_DATA_VEHICLES_TO_HISTORY', payload, date });
    },
    getHierarchy: () => dispatch(getHierarchy()),
    changeMenu: menu => dispatch({ type: 'CHANGE_MENU', menu }),
    hasDashboardToVehicle: payload =>
      dispatch({ type: 'SET_HASH_DASHBOARD_TO_VEHICLES', payload })
  };
};

const mapStateToProps = state => {
  const {
    fleet: { hierarchy },
    carrier
  } = state;
  let dropdownData = [];
  if (hierarchy && hierarchy.length > 0) {
    dropdownData = hierarchy.map(vehicle => {
      return vehicleTreeConstructor(vehicle, false);
    });
  }

  return {
    hierarchy: hierarchy || [],
    dropdownData,
    trainSelected: carrier.hashes.dashboardToVehicles
  };
};

const connectedVehicleMain = connect(
  mapStateToProps,
  mapDispatchToProps
)(VehicleMain);
export { connectedVehicleMain as VehicleMain };
